import React, { useState } from 'react'
import styled from 'styled-components'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Snackbar from '@mui/material/Snackbar'
import { createResource, useResource } from '@/lib/i18n'
import { submitByProduct } from '@/lib/api'
import Alert from '@mui/material/Alert'
import { useForm } from 'react-hook-form'
import { EmailReg, IdMobileReg } from '@/lib/constant'
import { eventLogProducer } from '@/lib/event-logger'
import { Action } from '@@/action_pb'

const resource = createResource({
  en: {
    email: 'Email',
    enterEmail: 'Enter email address',
    phone: 'Phone',
    enterPhone: 'Enter phone number',
  },
  id: {
    email: 'Email',
    enterEmail: 'Masukkan alamat email',
    phone: 'Telepon',
    enterPhone: 'Masukkan nomor telepon',
  },
})

type IProps = {
  name: string
}

const SubmitInfo = (props: IProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<any>()
  const { t } = useResource(resource)
  const [open, setOpen] = useState(false)
  const [openError, setOpenError] = useState(false)

  const onSubmit = async (data: { email: string; phone: string }) => {
    if (!data.email && !data.phone) return

    try {
      await submitByProduct({ email: data.email, phone: data.phone })
      setOpen(true)
    } catch (error) {
      setOpenError(true)
    }
  }
  const eventClick = () => {
    eventLogProducer.push({
      action: Action.SUBMITBUTTONCLICK,
    })
  }
  return (
    <SubmitStyle>
      <form onSubmit={handleSubmit(onSubmit)} className="right">
        <div className="input-box">
          <div className="text">{t('email')}</div>
          <div>
            <TextField
              {...register('email', { required: true, pattern: EmailReg })}
              id={`${props.name}standard-email-helper-text`}
              label={t('enterEmail')}
              variant="outlined"
              error={Boolean(errors.email)}
              style={{ width: '100%', background: 'white' }}
              helperText={Boolean(errors.email) ? 'Please check the email format' : ''}
            />
          </div>
        </div>
        <div className="input-box box2">
          <div className="text">{t('phone')}</div>
          <div>
            <TextField
              {...register('phone', { required: true, pattern: IdMobileReg })}
              id={`${props.name}outlined-basic-phone`}
              label={t('enterPhone')}
              variant="outlined"
              error={Boolean(errors.phone)}
              style={{ width: '100%', background: 'white' }}
              helperText={Boolean(errors.phone) ? 'Please check the your mobile' : ''}
            />
          </div>
        </div>
        <Button role="button" aria-disabled="false" type="submit" className="btn" onClick={eventClick}>
          Submit
        </Button>
      </form>
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={open}
        autoHideDuration={3000}
        onClose={() => setOpen(false)}
      >
        <Alert onClose={() => setOpen(false)} severity="success">
          Submitted successfully!
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={openError}
        autoHideDuration={3000}
        onClose={() => setOpen(false)}
      >
        <Alert onClose={() => setOpen(false)} severity="error">
          Too many requests, please try again later.
        </Alert>
      </Snackbar>
    </SubmitStyle>
  )
}

export default SubmitInfo

const SubmitStyle = styled.div`
  @media only screen and (max-width: 1000px) {
    .right {
      padding-top: 30px;
      width: 272px;
      margin: 0 auto;
      .input-box {
        .text {
          font-size: 14px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: #757575;
          line-height: 20px;
          padding-bottom: 8px;
        }
      }
      .box2 {
        padding-top: 24px;
      }
      .btn {
        margin-top: 32px;
        width: 100%;
        height: 40px;
        line-height: 40px;
        background-color: #1cc812;
        color: white;
        text-align: center;
        border-radius: 8px;
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    .right {
      padding-top: 58px;
      width: 420px;
      .input-box {
        .text {
          font-size: 16px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: #757575;
          line-height: 19px;
          padding-bottom: 13px;
        }
      }
      .box2 {
        padding-top: 26px;
      }
      .btn {
        margin-top: 32px;
        width: 100%;
        height: 56px;
        background-color: #1cc812;
        color: white;
        text-align: center;
        line-height: 56px;
        border-radius: 8px;
        cursor: pointer;
      }
    }
  }
`
